<template>
  <div class="repairReq-main">
    <div class="repairReq-main-step3">
      <el-row class="repairReq-main-step3-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step3-left"
        >
          <p class="font-format-normal">请根据您的实际情况，选择寄回设备</p>
          <!-- <p class="font-format-medium">
            说明说明说明说明说明说明说明说明说明说明
          </p> -->
          <!-- <p class="font-format-medium">
            说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明说明
          </p> -->
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step3-right"
        >
          <div class="repairReq-main-step3-typeSelect text-center">
            <el-radio v-model="selectType" :label="1"
              ><span class="font-format-normal">选择寄回故障设备</span>
            </el-radio>
            <!-- <el-radio v-model="selectType" :label="2"
              ><span class="font-format-normal">寄回全套</span></el-radio
            > -->
          </div>
          <div v-if="selectType === 1" class="repairReq-main-step3-parts">
            <el-checkbox-group v-model="device.fittings">
              <el-checkbox
                v-for="item in partsOpts"
                :key="item.id"
                :label="item.id"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-form :model="params" ref="form" :rules="rules" label-position="top">
        <el-row class="repairReq-main-step3-row">
          <el-col
            :xl="8"
            :lg="8"
            :md="8"
            :sm="24"
            class="repairReq-main-step3-left"
          >
            <p class="font-format-normal">请填写您的收货地址（维修后寄回用）</p>
          </el-col>
          <el-col
            :xl="14"
            :lg="14"
            :md="14"
            :sm="24"
            class="repairReq-main-step3-right"
          >
            <el-form-item label="姓名" prop="sendContact">
              <el-input
                v-model="params.sendContact"
                placeholder="姓名"
                clearable
              ></el-input>
            </el-form-item>

            <!-- 国外 -->
            <el-form-item label="手机" prop="sendAbroadPhone">
              <el-input
                ref="phone"
                v-model="params.sendPhone"
                oninput="value=value.replace(/[^\d]/g,'')"
                clearable
              />
            </el-form-item>

            <!-- 国内 -->
            <!-- <el-form-item label="手机" prop="sendPhone">
              <el-input
                v-model="params.sendPhone"
                placeholder="手机"
                oninput="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-form-item> -->

            <el-form-item label="邮箱">
              <el-input v-model="params.email" clearable />
            </el-form-item>

            <el-form-item label="邮政编码">
              <el-input v-model="params.zipCode" clearable />
            </el-form-item>

            <!-- 国外 -->
            <!-- <el-form-item label="国家" prop="country">
              <el-cascader
                style="width: 100%"
                v-model="params.country"
                :props="props"
                @change="areaChangeHandle"
              ></el-cascader>
            </el-form-item> -->

            <!-- 国内 -->
            <!-- <el-form-item label="所在地区" prop="area">
              <el-cascader
                style="width: 100%"
                v-model="params.area"
                :props="props"
                @change="areaChangeHandle"
              ></el-cascader>
            </el-form-item> -->

            <el-form-item label="详细地址" prop="tmpAddress">
              <el-input
                v-model="params.tmpAddress"
                placeholder="详细地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="repairReq-main-step3-row" ref="senderInfo">
          <el-col
            :xl="8"
            :lg="8"
            :md="8"
            :sm="24"
            class="repairReq-main-step3-left"
          >
            <p class="font-format-normal">
              请填写您寄出的快递信息<span style="color: red"
                >（如暂无快递信息，请先做暂存，获取快递单号再进行更新提交）</span
              >
            </p>
          </el-col>
          <el-col
            :xl="14"
            :lg="14"
            :md="14"
            :sm="24"
            class="repairReq-main-step3-right"
          >
            <div class="repairReq-main-step3-form">
              <el-form-item prop="customer" v-if="!$route.query.t">
                <div slot="label" class="repairReq-main-step3-label">
                  <p>寄件人姓名</p>
                  <el-button type="primary" @click="syncUserInfo()"
                    >同步回寄信息</el-button
                  >
                </div>
                <el-input
                  v-model="params.customer"
                  placeholder="请输入您寄出快递所填写的姓名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label="寄件人手机"
                prop="phone"
                v-if="!$route.query.t"
              >
                <el-input
                  v-model="params.phone"
                  placeholder="请输入您寄出快递所填写的手机号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="快递公司" prop="receiveDeliveryInc">
                <div class="receiveDeliveryInc-form-item">
                  <el-select
                    v-model="params.receiveDeliveryInc"
                    placeholder="请选择快递公司"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in expressOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div class="repairReq-header-mobile">
                    <el-popover placement="top" width="200" trigger="click">
                      <div>
                        <p class="font-format-medium2">联系人：文石售后维修</p>
                        <p class="font-format-medium2">电话：4008-860-830</p>
                        <p class="font-format-medium2">
                          地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）
                        </p>
                      </div>
                      <div style="text-align: right; margin: 0">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="copyAddress"
                          >复制</el-button
                        >
                      </div>
                      <el-button slot="reference" size="mini" type="primary"
                        >寄修地址</el-button
                      >
                    </el-popover>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="快递单号" prop="receiveDeliveryCode">
                <el-input
                  v-model="params.receiveDeliveryCode"
                  placeholder="为确保运送安全，建议使用顺丰，请勿到付！"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="repairReq-main-step3-tips">
              <p class="font-format-medium">寄件需知：</p>
              <p class="font-format-medium">
                1、如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。
              </p>
              <p class="font-format-medium">
                2、寄修前请自行做好数据备份，因维修导致的数据丢失，文石概不负责；
              </p>
              <p class="font-format-medium">
                3、快件打包请注意保护好屏幕，避免运输中有损坏；
              </p>
              <p class="font-format-medium">
                4、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；
              </p>
              <p class="font-format-medium">
                5、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询；
              </p>
              <p class="font-format-medium">
                6、经文石检测确认后，需付费维修的设备，从文石发起付费通知七个工作日后如仍未付费确认维修，文石售后维修中心会将设备原路寄回；
              </p>
              <p class="font-format-medium">
                7、运费双方各支付一程，请勿寄到付，到付拒收；
              </p>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="repairReq-step3-privacy">
      <el-checkbox v-model="privacyAgreed">
        我已阅读并同意
        <span class="privacy-link" @click="showPrivacyDialog = true"
          >《隐私政策》</span
        >
      </el-checkbox>
    </div>
    <div class="repairReq-step3-next">
      <el-button type="text" @click="goBack">返回上一步</el-button>
      <el-button type="warning" size="default" @click="saveData(-1, 'form')"
        >暂存</el-button
      >
      <el-button type="primary" size="default" @click="submitForm('form')"
        >下一步</el-button
      >
    </div>
    <PrivacyPolicyDialog
      :visible.sync="showPrivacyDialog"
      @agree="handlePrivacyAgree"
    />
  </div>
</template>

<script>
import intTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import PrivacyPolicyDialog from "@/views/repair/components/PrivacyPolicyDialog.vue";
export default {
  components: {
    PrivacyPolicyDialog,
  },
  props: {
    device: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  computed: {
    rules() {
      let rules = {
        area: [{ required: true, message: "地区不能为空", trigger: "blur" }],
        tmpAddress: [
          { required: true, message: "地址不能为空", trigger: "blur" },
        ],
        sendContact: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        sendPhone: [
          { required: true, validator: this.checkphone, trigger: "blur" },
        ],
        sendAbroadPhone: [
          { required: true, validator: this.checkAbroadphone, trigger: "blur" },
        ],
        email: [
          { required: true, validator: this.checkEmail, trigger: "blur" },
        ],
        zipCode: [
          { required: true, validator: this.checkZipCode, trigger: "blur" },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      intTelInput: null,
      selectType: 1,
      partsOpts: [],
      privacyAgreed: false,
      showPrivacyDialog: false,
      expressOpts: [
        {
          label: "京东",
          value: "jd",
        },
        {
          label: "德邦",
          value: "debangkuaidi",
        },
        {
          label: "顺丰",
          value: "shunfeng",
        },
        {
          label: "极兔",
          value: "jtexpress",
        },
        {
          label: "圆通",
          value: "yuantong",
        },
        {
          label: "申通",
          value: "shentong",
        },
        {
          label: "中通",
          value: "zhongtong",
        },
        {
          label: "韵达快递",
          value: "yunda",
        },
        {
          label: "邮政标准快递",
          value: "youzhengbk",
        },
        {
          label: "EMS",
          value: "ems",
        },
        {
          label: "其他",
          value: "other",
        },
      ],

      props: {
        lazy: true,
        label: "name",
        value: "name",
        lazyLoad: async (node, resolve) => {
          let arr = [];
          let params = {};
          if (node.level === 0) {
            let res = await this.getArealist();
            arr = res.data;
          } else {
            switch (node.level) {
              case 1:
                params = {
                  province: node.data.province,
                };
                break;
              case 2:
                params = {
                  province: node.data.province,
                  city: node.data.city,
                };
                break;
              case 3:
                params = {
                  province: node.data.province,
                  city: node.data.city,
                  area: node.data.area,
                };
                break;
              default:
                break;
            }
            let res = await this.getArealist(params);
            arr = res.data;
          }
          for (let item of arr) {
            if (item.town !== "0") {
              item.leaf = true;
            }
          }
          resolve(arr);
        },
      },
    };
  },
  methods: {
    copyAddress() {
      let str = `联系人：文石售后维修\n电话：13826127601\n地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）`;
      navigator.clipboard.writeText(str);
    },
    checkphone(rule, value, callback) {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    },
    checkAbroadphone(rule, value, callback) {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else {
        callback();
      }
    },
    checkEmail(rule, value, callback) {
      if (value == "") {
        callback(new Error("请输入邮箱"));
      } else {
        callback();
      }
    },
    checkZipCode(rule, value, callback) {
      if (value == "") {
        callback(new Error("请输入邮政编码"));
      } else {
        callback();
      }
    },
    goBack() {
      this.setFittingsData();
      this.$emit("goBack");
    },
    handlePrivacyAgree() {
      this.privacyAgreed = true;
    },
    nextPage() {
      this.setFittingsData();
      this.$emit("nextPage");
    },

    setFittingsData() {
      if (!this.device.fittings.length) return;
      this.device.fittingsData = this.partsOpts.filter((item) =>
        this.device.fittings.includes(item.id)
      );
    },

    async getFittinglist() {
      let res = await this.$http.getFittinglist();
      this.partsOpts = res.data || [];

      if (this.device.fittings.length === 0) {
        const parts = this.partsOpts.find((item) => item.name === "裸机");
        if (parts) {
          this.device.fittings.push(parts.id);
        }
      }
    },

    syncUserInfo() {
      this.params.customer = this.params.sendContact;
      this.params.phone = this.params.sendPhone;
    },
    getArealist(params) {
      return this.$http.getArealist(params);
    },

    areaChangeHandle() {},

    submitForm(formName) {
      if (!this.privacyAgreed) {
        this.$message.warning("请先阅读并同意隐私政策");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.params.areaCode = this.intTelInput.selectedCountryData;
          this.params.country = this.params.areaCode.name;
          if (!this.params.phone) {
            this.params.phone = !this.$route.query.p
              ? this.params.sendPhone
              : this.$route.query.p;
          }

          if (!this.params.customer) {
            this.params.customer = !this.$route.query.n
              ? this.params.sendContact
              : this.$route.query.n;
          }
          this.nextPage();
        } else {
          return false;
        }
      });
    },

    async saveData(status, formName) {
      try {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.params.areaCode = this.intTelInput.selectedCountryData;
            this.params.country = this.params.areaCode.name;
            if (!this.params.phone) {
              this.params.phone = !this.$route.query.p
                ? this.params.sendPhone
                : this.$route.query.p;
            }

            if (!this.params.customer) {
              this.params.customer = !this.$route.query.n
                ? this.params.sendContact
                : this.$route.query.n;
            }
            this.$emit("saveData", status);
          } else {
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  destroyed() {
    if (this.intTelInput) this.intTelInput.destroy();
  },
  mounted() {
    const input = this.$refs.phone.$refs.input;
    if (this.intTelInput) this.intTelInput.destroy();
    this.intTelInput = intTelInput(input, {
      separateDialCode: true,
      showFlags: true,
      preferredCountries: [],
      initialCountry: this.params.areaCode.iso2 || "cn",
    });
    this.getFittinglist();

    // 检查是否从隐私政策页面返回并已同意
    if (this.$route.query.privacyAgreed === "true") {
      this.privacyAgreed = true;
    }

    if (this.$route.query.id && this.$route.query.t) {
      // 小程序编辑寄修单调用
      this.$refs.senderInfo ? this.$refs.senderInfo.$el.scrollIntoView() : null;
    }
    if (this.$local.get("tips")) return;
    let str = `
                <p class=font-format-medium>如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。</p>
              `;
    this.$confirm(str, "温馨提示", {
      dangerouslyUseHTMLString: true,
      showCancelButton: false,
    });
    this.$local.set("tips", true);
  },
};
</script>

<style lang="scss">
.repairReq-main {
  .repairReq-main-step3 {
    .repairReq-main-step3-row + .repairReq-main-step3-row {
      border-top: 1px dashed #eee;
    }
    .repairReq-main-step3-row {
      padding: 30px 0;
      .repairReq-main-step3-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairReq-main-step3-right {
        .repairReq-main-step3-form {
          .receiveDeliveryInc-form-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          > .el-form-item {
            > .el-form-item__label {
              width: 100%;
              .repairReq-main-step3-label {
                display: flex;
                justify-content: space-between;
              }
            }
          }
          .repairReq-main-step3-formItem + .repairReq-main-step3-formItem {
            margin-top: 20px;
          }
          .repairReq-main-step3-formItem {
            > .el-input {
              flex: 1;
              margin-top: 5px;
            }
          }
        }

        .repairReq-main-step3-parts {
          margin-top: 20px;
        }
        .repairReq-main-step3-tips {
          margin-top: 20px;
        }
      }
    }
  }

  .iti--separate-dial-code {
    width: 100%;
  }

  .repairReq-step3-privacy {
    padding: 20px 0;
    border-top: 1px solid #eee;
    text-align: center;

    .privacy-link {
      color: #409eff;
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .repairReq-step3-next {
    padding-top: 30px;
    border-top: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    > .el-button:nth-child(3) {
      padding: 12px 40px;
    }
    > .el-button + .el-button {
      margin-left: 0;
    }
  }
}

@media (max-width: 1000px) {
  .repairReq-main-step3-right {
    margin-top: 20px;
    .repairReq-sn-input {
      flex-direction: column;
      > .el-input {
        width: 100% !important;
      }
      > .el-button {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }
}
@media (max-width: 700px) {
  .repairReq-step3-next {
    position: absolute;
    left: 0;
    bottom: 10px;
    border: 0 !important;
    padding-top: 0px !important;
    box-shadow: 0 -1px 8px 4px #eee;
    > .el-button {
      /* flex: 1; */
      /* border-radius: 0; */
      margin: 0 12px;
    }
  }
}
</style>
